import { useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { GlobalStyles } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { useMatch } from "@covertree/hooks";
import { GoBackButton } from "@covertree/ui/buttons/GoBackButton";

export interface AuthLayoutHandle {
  canGoBack: boolean;
  title: string;
  subtitle: string;
}

export const AuthLayout = ({
  loginPath,
  logo,
}: {
  loginPath: string;
  logo: React.ReactNode;
}) => {
  const match = useMatch<AuthLayoutHandle>();

  const canGoBack = match?.handle?.canGoBack ?? false;

  const contentContainer = useRef<HTMLDivElement>(null);

  if (!match.handle) {
    return <Navigate to={loginPath} />;
  }

  const { title, subtitle } = match.handle;

  return (
    <Container maxWidth="xs">
      <GlobalStyles
        styles={() => ({
          "html body": {
            overflowY: "scroll",
          },
        })}
      />
      <Box mb={2} mt={canGoBack ? 8 : 19}>
        <Box ref={contentContainer}>
          <Box mb={2}>
            {Boolean(canGoBack) && (
              <Box height={40}>
                <GoBackButton />
              </Box>
            )}
            <Box mt={canGoBack ? 6 : 0}>{logo}</Box>
            <Typography
              data-testid={`${title}-title`}
              variant="h3"
              mt={3}
              mb={2}>
              {title}
            </Typography>
            <Typography data-testid={`${title}-subtitle`} variant="h6">
              {subtitle}
            </Typography>
          </Box>
          <Outlet />
        </Box>
      </Box>
    </Container>
  );
};

export default AuthLayout;
